export default __webpack_public_path__ + "static/media/electricalServices.796abd4c.jpg";